module.exports = __webpack_public_path__ + "static/media/Wah HD VR.f3dac96.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page/hd-racks/Wah HD VR.mp3
// module id = DNxe
// module chunks = 12